import { render, staticRenderFns } from "./TaskPeriodization.vue?vue&type=template&id=c27e52b2&lang=pug"
import script from "./TaskPeriodization.vue?vue&type=script&lang=js"
export * from "./TaskPeriodization.vue?vue&type=script&lang=js"
import style0 from "./TaskPeriodization.vue?vue&type=style&index=0&id=c27e52b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports